import * as yup from 'yup';
import { NomineeAgent } from '@features/api/response/NomineeAgent';
import { NomineeCustomer } from '@features/api/response/NomineeCustomer';
import { NewNomineeInvestmentAttribution } from '@features/api/request/NomineeInvestmentAttribution';

export const nomineeAgentFormSchema = yup.object<
  Record<keyof Omit<NomineeAgent, 'id'>, yup.AnySchema>
>({
  email: yup.string().trim().required().email(),
  name: yup.string().required(),
});

export const nomineeCustomerFormSchema = yup.object<
  Record<keyof Omit<NomineeCustomer, 'id' | 'categorizedData'>, yup.AnySchema>
>({
  firstName: yup.string().trim().required(),
  middleName: yup.string().trim(),
  lastName: yup.string().trim().required(),
});

export const NomineeInvestmentAttributionFormScema = yup.object<
  Record<keyof NewNomineeInvestmentAttribution, yup.AnySchema>
>({
  amount: yup.string().trim().required(),
  nomineeCustomerId: yup.string().trim().required(),
  transactionId: yup.string().trim().required(),
});
